import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=56709e6c&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=56709e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56709e6c",
  null
  
)

export default component.exports